<div class="row h-100 dashboard-div">
  @if (isLoading) {
    <div class="col-12 text-center">
      <br /><br />
      <img id="loadingImg" src="assets/loadingSpinner.gif" />
      <br />
      <br />
    </div>
  } @else {
    <div class="col-12 text-center pt-4 pb-4">
      <div class="card border-0">
        <div class="card-body">
          <h4 class="card-title">
            Sorry, we are currently unable to access this view. Please try
            closing your browser and logging in through Encompass again.
          </h4>
          @if (loginUrl) {
            <div class="card-text">
              Or you can click the login button below to try re-authenticating.
              <div class="p-1">
                <button
                  (click)="login()"
                  class="m-3btn btn-primary btn-lg"
                  id="loginBtn"
                >
                  Login
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
